import { useMutation, useQuery } from '@apollo/client'
import { Select } from 'antd'
import React from 'react'
import { DEMANDE_UPDATE } from '../../../apollo/mutation/demande.mutation'
import { SINISTRE_BY_ID } from '../../../apollo/query/demande.query'
import { D4_Demande_Set_Input } from '../../../types'

const SelectNatureSinistre = ({ demandeId }: { demandeId: number }) => {
  const [updateDemande] = useMutation<{}, { id: number; data: D4_Demande_Set_Input }>(DEMANDE_UPDATE)
  const { data, loading } = useQuery(SINISTRE_BY_ID, { variables: { id: demandeId } })

  const handleSelect = async (value: string) => {
    await updateDemande({
      variables: {
        id: demandeId,
        data: { naturesinistre: value },
      },
    })
  }

  if (loading) {
    return null
  }

  return (
    <Select
      style={{ minWidth: '240px' }}
      placeholder="Nature"
      listHeight={800}
      onChange={handleSelect}
      defaultValue={data?.demande?.naturesinistre}
    >
      <Select.Option value="0">Incendie</Select.Option>
      <Select.Option value="1">Degat des eaux</Select.Option>
      <Select.Option value="2">Bris de glace</Select.Option>
      <Select.Option value="3">Vandalisme</Select.Option>
      <Select.Option value="4">Dommage ouvrage</Select.Option>
      <Select.Option value="5">Autre</Select.Option>
      <Select.Option value="6">Responsabilite civile</Select.Option>
      <Select.Option value="7">Dommage electrique</Select.Option>
      <Select.Option value="8">Catastrophe naturelle</Select.Option>
      <Select.Option value="9">Tempete ouragan grele</Select.Option>
      <Select.Option value="10">Choc de vehicule</Select.Option>
      <Select.Option value="11">Vol</Select.Option>
    </Select>
  )
}

export default SelectNatureSinistre
